
















import { Expression, isString, ConstantExpression, PathExpression, GetExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<PathExpression>().extend({
  name: 'PathViewer',
  methods: {
    getSegmentClass(segment: Expression, index: number) {
      return (segment instanceof ConstantExpression && isString(segment.value)) || segment.isPathNode()
        ? ''
        : index === 0
          ? 'ex-parenthesis'
          : 'ex-brackets';
    },
    getSegmentPrefix(segment: Expression, index: number) {
      return (segment instanceof ConstantExpression && isString(segment.value)) || segment.isPathNode()
        ? (index > this.getFirstIndex() ? '.' : '')
        : '';
    },
    getFirstIndex(): number {
      return this.value.expressions[0] instanceof GetExpression ? 1 : 0;
    },
  },
});
